import React, { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useOrganizerAuth } from '../../context/OrganizerAuthContext';
import { AdminShell, LoginCard, Field, Btn, ErrorText, PageTitle } from '../../styles/adminStyles';
import LanguageSwitcher from '../../components/LanguageSwitcher';
import { usePortalT } from '../../i18n/usePortalT';

export default function OrganizerLoginPage() {
  const { user, login, loading } = useOrganizerAuth();
  const navigate = useNavigate();
  const { t } = usePortalT();
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user) {
    return <Navigate to="/organizer" replace />;
  }

  if (loading) {
    return (
      <AdminShell>
        <LoginCard>
          <PageTitle>{t('orgLogin.loadingTitle')}</PageTitle>
          <p style={{ color: '#64748b', fontSize: 14 }}>{t('common.loading')}</p>
        </LoginCard>
      </AdminShell>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    const out = await login(identifier, password);
    setSubmitting(false);
    if (out.success) {
      navigate('/organizer', { replace: true });
    } else {
      setError(out.error || t('orgLogin.failed'));
    }
  };

  return (
    <AdminShell>
      <LoginCard>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
          <LanguageSwitcher />
        </div>
        <PageTitle>{t('orgLogin.titleFull')}</PageTitle>
        <p style={{ color: '#64748b', fontSize: 14, marginBottom: 24 }}>
          {t('orgLogin.subtitle')}
        </p>
        <form onSubmit={handleSubmit}>
          <Field>
            {t('orgLogin.userLabel')}
            <input
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              autoComplete="username"
              required
            />
          </Field>
          <Field>
            {t('orgLogin.passwordLabel')}
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </Field>
          {error ? <ErrorText>{error}</ErrorText> : null}
          <Btn $primary type="submit" disabled={submitting} style={{ width: '100%', marginTop: 8 }}>
            {submitting ? t('orgLogin.signingIn') : t('orgLogin.signIn')}
          </Btn>
        </form>
        <p style={{ color: '#94a3b8', fontSize: 13, marginTop: 20, textAlign: 'center' }}>
          {t('orgLogin.adminPrompt')}
          <Link to="/admin/login" style={{ color: '#2563eb', fontWeight: 600, marginLeft: 4 }}>
            {t('orgLogin.adminLink')}
          </Link>
        </p>
      </LoginCard>
    </AdminShell>
  );
}
